import { PreloadedQuery } from 'react-relay';

import { RelayResourceConfig, createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type {
	RouterContext,
	RouterDataContext,
	RouteResource,
} from '@townsquare/router/routing-types';

import TeamTqlExplainerAggQueryNode, {
	TeamTqlExplainerAggQuery,
} from '../components/__generated__/TeamTqlExplainerAggQuery.graphql';

export const getTeamTqlExplainerAggResourceQuery = (
	routerContext: RouterContext | RouterDataContext,
): RelayResourceConfig<TeamTqlExplainerAggQuery> => {
	const { tql } = routerContext.query;

	return {
		environment: getAggRelayEnvironment(),
		query: TeamTqlExplainerAggQueryNode,
		variables: {
			searchString: tql ?? '',
			includeTeams: !!tql,
		},
		options: {
			fetchPolicy: 'store-and-network',
		},
	};
};

export const tqlExplainerTeamAggResource: RouteResource<
	PreloadedQuery<TeamTqlExplainerAggQuery, Record<string, unknown>>
> = createRelayResource<TeamTqlExplainerAggQuery>({
	getQuery: getTeamTqlExplainerAggResourceQuery,
});
